import React, {ReactElement} from "react";
import {useTheme} from "@material-ui/core/styles";
import useStyles from "./styles";

type StepperImageContainerProps = {
  icon: ReactElement;
  completed: boolean;
  small?: boolean;
};

const StepperImageContainer = ({
  icon,
  completed,
  small,
}: StepperImageContainerProps): ReactElement => {
  const classes = useStyles(small);
  const theme = useTheme();
  const backgroundColor = completed
    ? theme.palette.primary.main
    : theme.palette.gray2.main;
  return (
    <div style={{backgroundColor}} className={classes.stepperImageContainer}>
      {icon}
    </div>
  );
};
StepperImageContainer.defaultProps = {
  small: false,
};

export default StepperImageContainer;
